import { createFileRoute } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";
import React from "react";

import { useAuth } from "#app/lib/auth-context";
import { AnalyticsContext, AuthEvent, trackEvent } from "#app/lib/analytics";

function LogoutScreen() {
  const { signOut } = useAuth();

  React.useEffect(() => {
    document.title = "Logging Out - SalesTrak";
    trackEvent({ context: AnalyticsContext.Auth, event: AuthEvent.SignOut, data: { via: "logout_route" } });
    signOut();
  }, [signOut]);

  return (
    <Box fill="flex" align="center" justify="center">
      <Spinner color="muted" size="2xl" />
    </Box>
  );
}

export const Route = createFileRoute("/logout")({ component: LogoutScreen });
